;(function (angular) {
    'use strict';

    angular
        .module('SMART2')
        /**
         * @ngdoc service
         * @name SMART2.config
         * @description
         * It contains the routing configuration.
         */
        .config(['$stateProvider', '$urlRouterProvider', '$translateProvider', 'APPCONSTANTS', '$controllerProvider', '$compileProvider', '$filterProvider', '$provide', 'dependencyResolverProvider', 'CONSTANTS', routeConfigFunc])

    /**   
     * @param {Object} $stateProvider The new $stateProvider works similar to Angular's v1 router, but it focuses purely on state.
     * @param {Object} $urlRouterProvider $urlRouterProvider has the responsibility of watching $location. When $location changes it runs through a list of rules one by one until a match is found. $urlRouterProvider is used behind the scenes anytime you specify a url in a state configuration. All urls are compiled into a UrlMatcher object. <br/><br/> There are several methods on $urlRouterProvider that make it useful to use directly in your module config.
     */
    function routeConfigFunc($stateProvider, $urlRouterProvider, $translateProvider, APPCONSTANTS, $controllerProvider, $compileProvider, $filterProvider, $provide, dependencyResolverProvider, CONSTANTS) {
        var ver = "?ver=" + APPCONSTANTS.userPreferences.ScriptVersion;
        angular.module('SMART2').register = {
            controller: $controllerProvider.register,
            directive: $compileProvider.directive,
            filter: $filterProvider.register,
            factory: $provide.factory,
            service: $provide.service
        };

        var minValue = "", bldVer = typeof buildVersion !== 'undefined' ? (buildVersion + "/") : "";
        if (deployType.toLowerCase() !== "dev") {
            minValue = ".min";
        }

        $urlRouterProvider.otherwise('/');

        $stateProvider
            .state('landing', dependencyResolverProvider.resolve({
                url: '/',
                templateUrl: 'public/rfx/landingPage/view/landingPublicRfx.html',
                controller: 'landingPageCtrl as vm',
                dependencies: [                         
                          APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/distribution/" + bldVer + "workspace.dist/public/rfx/rfxLazyLoadedTemplate" + minValue + ".js" + ver,
                          APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/distribution/" + bldVer + "workspace.dist/public/rfx/rfx" + minValue + ".js" + ver
                ]
            }))
    }
})(angular);
